import Enum from './enum'

class OperationField extends Enum
{
  constructor(value) {
    super(value);
  }
}

OperationField.init({
  POSITION: 'Position',
  DISMISS: 'Dismiss',
  CURRENCY_CLAUSE: 'CurrencyClause',
  PERCENT: 'Percent',
  FIX_DATE: 'FixDate',
  ADDITIONAL_NOMEN: 'AdditionNomen',
  SYNDICATE: 'Syndicate',
  BID_CURRENCY: 'CurrencyBid',
  PAY_CURRENCY: 'CurrencyPay',
  PRICE: 'Price',
  COUNT: 'Count',
  DURATION: 'Duration',
  DELIVERY_DATETIME: 'DeliveryDatetime',
  RECEIVE_DATETIME: 'ReceiveDatetime',
  DELIVERY_TIME: 'DeliveryTime',
  DAYS: 'Days',
  PRC: 'Prc',
  VALUE: 'Value'
}, {
  POSITION: 'operation-field.position',
  DISMISS: 'operation-field.dismiss',
  CURRENCY_CLAUSE: 'operation-field.currency-clause',
  PERCENT: 'operation-field.percent',
  FIX_DATE: 'operation-field.fix-date',
  ADDITIONAL_NOMEN: 'operation-field.addition-nomen',
  SYNDICATE: 'operation-field.syndicate',
  BID_CURRENCY: 'operation-field.bid-currency',
  PAY_CURRENCY: 'operation-field.pay-currency',
  PRICE: 'operation-field.price',
  COUNT: 'operation-field.count',
  DURATION: 'operation-field.duration',
  DELIVERY_DATETIME: 'operation-field.delivery-datetime',
  RECEIVE_DATETIME: 'operation-field.receive-datetime',
  DELIVERY_TIME: 'operation-field.delivery-time',
  DAYS: 'operation-field.days',
  PRC: 'operation-field.prc',
  VALUE: 'operation-field.value'
});

export default OperationField;
